import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompletedOpportunitiesComponent } from './modules/completed-opportunities/completed-opportunities.component';
import { StartApplicationComponent } from './modules/start-application/start-application.component';
import { UserFormComponent } from './modules/shared-component/user-form/user-form.component';
import { UserNotificationComponent } from './modules/user-notification/user-notification.component';
import { AuthGuard } from './route-guard/auth-guard.service';

import { IsOpportunityGuard } from './route-guard/is-opportunity.guard.service';
import { UpdatePasswordComponent } from './modules/users/update-password/update-password.component';
import { MessagePortalComponent } from './modules/message-portal/message-portal.component';
import { SelectedMessageComponent } from './modules/message-portal/selected-message/selected-message.component';
import { LoginPageComponent } from './modules/users/login-page/login-page.component';
import { LifeInsuranceApplicationModule } from './modules/life-insurance-application/life-insurance-application.module';
const routes: Routes = [
  // route without authGuard
  // start page  // no auth guard
  {
    path: '',

    pathMatch: 'full',
    component: StartApplicationComponent,
    data: { title: 'Start Application', breadcrumb: 'Start Application' },
  },

  // all application register page  // no auth guard
  {
    path: 'debtapp',

    component: UserFormComponent,
  },
  {
    canActivate: [AuthGuard],
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'life-insurance',

    component: UserFormComponent,
  },
  {
    path: 'financial-planning',

    component: UserFormComponent,
  },
  {
    path: 'superannuation',

    component: UserFormComponent,
  },
  {
    path: 'managed-account',

    component: UserFormComponent,
  },
  {
    path: 'general-insurance',

    component: UserFormComponent,
  },
  {
    path: 'estate-planning',

    component: UserFormComponent,
  },
  {
    path: 'health-insurance',

    component: UserFormComponent,
  },

  {
    path: 'user/update-password/:contactId',
    component: UpdatePasswordComponent,
  },
  {
    path: 'user/create-password/:contactId',
    component: UpdatePasswordComponent,
  },

  {
    path: 'accountant',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/accountant-portal/accountant-portal.module').then(
        (m) => m.AccountantPortalModule
      ),
  },
  {
    path: 'user',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/users/users.module').then((m) => m.UsersModule),
  },

  {
    path: 'superannuation',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/superannuation/superannuation.module').then(
        (m) => m.SuperannuationModule
      ),
  },

  {
    path: 'managed-account',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/managed-account/managed-account.module').then(
        (m) => m.ManagedAccountModule
      ),
  },

  {
    path: 'general-insurance',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/general-insurance/general-insurance.module').then(
        (m) => m.GeneralInsuranceModule
      ),
  },

  {
    path: 'estate-planning',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/estate-planning/estate-planning.module').then(
        (m) => m.EstatePlanningModule
      ),
  },

  {
    path: 'health-insurance',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import('./modules/health-insurance/health-insurance.module').then(
        (m) => m.HealthInsuranceModule
      ),
  },

  {
    path: 'life-insurance',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import(
        './modules/life-insurance-application/life-insurance-application.module'
      ).then((m) => m.LifeInsuranceApplicationModule),
  },

  {
    path: 'financial-planning',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import(
        './modules/financial-planning-application/financial-planning-application.module'
      ).then((m) => m.FinancialPlanningApplicationModule),
  },

  {
    path: 'uikit',
    loadChildren: () =>
      import('./modules/uikit/uikit.module').then((m) => m.UiKitModule),
  },
  {
    path: 'financial-goal',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/financial-goal/financial-goal.module').then(
        (m) => m.FinancialGoalModule
      ),
  },
  {
    path: 'refinance-consolidation',
    canActivate: [AuthGuard, IsOpportunityGuard],
    loadChildren: () =>
      import(
        './modules/refinance-consolidation/refinance-consolidation.module'
      ).then((m) => m.RefinanceConsolidationModule),
  },
  {
    path: 'completed',
    canActivate: [AuthGuard],
    component: CompletedOpportunitiesComponent,
    data: {
      title: 'Completed Application',
      breadcrumb: 'Completed Application',
    },
  },
  {
    path: 'notification',
    canActivate: [AuthGuard],
    component: UserNotificationComponent,
    data: { title: 'Notification', breadcrumb: 'User Notification' },
  },
  {
    path: 'message',
    canActivate: [AuthGuard],
    component: MessagePortalComponent,
    data: { title: 'Messages', breadcrumb: 'User message' },
  },
  {
    path: 'selected-message',
    canActivate: [AuthGuard],
    component: SelectedMessageComponent,
    data: { title: 'Selected Messages', breadcrumb: 'User message' },
  },
  {
    path: 'side-nav',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/side-nav-components/side-nav-components.module').then(
        (m) => m.SideNavComponentsModule
      ),
  },
  {
    path: 'family',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/side-nav-components/family/family.module').then(
        (m) => m.FamilyModule
      ),
  },
  {
    path: 'invest',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/side-nav-components/additional-services/investment-and-superannuation/investment-and-superannuation.module'
      ).then((m) => m.InvestmentAndSuperannuationModule),
  },

  {
    path: 'debt',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/side-nav-components/additional-services/debt/debt.module'
      ).then((m) => m.DebtModule),
  },
  {
    path: 'financial-plan',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/side-nav-components/additional-services/financial-planning/financial-planning.module'
      ).then((m) => m.FinancialPlanningModule),
  },

  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
